import { Link } from 'react-router-dom';
import { openZohoChat } from '../utils/openZohoChat';

export default function PolicyLayout({ title, updated, intro, children }) {
  return (
    <div className="page page--policy">
      <section className="policy-hero">
        <div className="shell">
          <p className="policy-hero__crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>{title}</span>
          </p>
          <h1>{title}</h1>
          {updated ? <p className="policy-hero__updated">Last updated: {updated}</p> : null}
        </div>
      </section>

      <div className="shell policy-body">
        <article className="policy-card">
          {intro ? <p className="policy-card__intro">{intro}</p> : null}
          {children}

          <h2>Need help?</h2>
          <p>Open live chat with our support team — we are available around the clock.</p>
          <button type="button" className="btn btn--primary" onClick={openZohoChat}>
            Start Live Chat
          </button>
        </article>
      </div>
    </div>
  );
}
